module.exports = __webpack_public_path__ + "assets/menu.ec9f249b.svg";